import { Button, Col, Row, Form, FormInstance, notification } from "antd";
import APagarLancamentoFormBasic, { IAPagarLancamentoFormBasicProps } from "./APagarLancamentoFormBasic";
import { useLancamentoAPagar } from "@/Services/Financeiro/Titulo/ParcelaService";
import { LancamentoType } from "@/Services/Financeiro/Titulo/ParcelaService";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import { useBuscarMutation } from "@/Services/Financeiro/Titulo/TituloService";
import { useEffect, useRef } from "react";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
import { EnumPessoaTipo } from "@/Models/Pessoa/Pessoa";

export interface IAPagarLancamentoFormProps extends IAPagarLancamentoFormBasicProps {
    onSuccess?:(variables: LancamentoType, form: FormInstance<LancamentoType>) => void;
    onCancelar?:(e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onErroPopular?:() => void;
    isButtonCancelar?: boolean;
    popular?: boolean;
    codigo?: number;
}

export default function APagarLancamentoForm({
    onSuccess : onSuccessParam,
    onCancelar : onCancelarParam,
    form : formParam,
    disabled,
    codigo,
    popular,
    initialValues,
    onErroPopular,
    isButtonCancelar,
    ...rest
}:IAPagarLancamentoFormProps) {
    popular = popular ?? false;
    codigo = codigo ?? undefined;

    const [newForm] = Form.useForm<LancamentoType>();
    const refForm = useRef<FormInstance<LancamentoType>>(null);
    const form = formParam ?? newForm;
    
    const {
        mutate,
        isPending
    } = useLancamentoAPagar({
        onSuccess : (_, v) => {
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Lançamento realizado com sucesso."
            });

            if (onSuccessParam !== undefined) 
            {
                onSuccessParam?.(v, form);
                form.resetFields();
            }
            else
                form.resetFields();
        }
    });

    const {
        isPending : isPendingBuscar,
        mutate : mutationBuscar,
        data
    } = useBuscarMutation({
        onSuccess(data, variables, context) {
            //form.resetFields();
        },
        onError(error, variables, context) {
            notification.info({
                ...PropriedadesDeNotificacao["Aviso"],
                message: "Não foi possível encontrar o titulo que deseja alterar.",
            });

            form.resetFields();
            onErroPopular?.();
        },
    });

    const initValues = popular ? { titulo : data?.data ?? undefined } : initialValues;

    const handleCancelar = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        form.resetFields();
        onCancelarParam?.(e);
    }

    const handleSalvar = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        form.submit();
    }

    useEffect(() => {
        const isAlteracao = codigo !== undefined && isFinite(codigo) && !isNaN(codigo) && (codigo ?? 0) > 0;
        if (popular && isAlteracao)     
        {
            mutationBuscar({
                codigo : (codigo ?? 0)
            });
        }
    }, [codigo, popular]);

    return <TelaCarregamento ativo={popular ? isPendingBuscar : false}>
        {(popular === false || initValues?.titulo?.devedor?.tipo === EnumPessoaTipo.EMPRESA) && <APagarLancamentoFormBasic
            {...rest}
            ref={refForm}
            component="div"
            onFinish={mutate}
            disabled={isPending ? true : disabled}
            initialValues={initValues}
            form={form}
        >
            {(disabled ?? false) === false && <Row justify={'center'} gutter={8} style={{ width : "100%", marginBottom : 8 }}>
                <Col xs={"auto"}>
                    <Button type="primary" loading={isPending} htmlType="button" onClick={handleSalvar}>Salvar</Button>
                </Col>
                {isButtonCancelar !== true && <Col xs={"auto"}>
                    <Button type="primary" loading={isPending} danger htmlType="button" onClick={handleCancelar}>Cancelar</Button>
                </Col>}
            </Row>}
        </APagarLancamentoFormBasic>}
    </TelaCarregamento>;
}